//import axios from "axios"
const GROBAL = {
  BASE_SERVER: {
    URL: 'http://122.155.108.236:6201/',
    // URL: "http://127.0.0.1:6201/",
  },
  API: {
    NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: "AIzaSyA8_Zs4UJy-HUw8Lc17gxMOxrhNF7pEqCI",
  },
  // -----------------------------------------------------------------------------------

  ACCESS_TOKEN: {
    "x-access-token": localStorage.getItem("x-access-token"),
    school_table_uuid: localStorage.getItem("school_table_uuid"),
  },
  PERMISSION: {
    permission: localStorage.getItem("permission"),
    temp_permission: localStorage.getItem("temp_permission"),
  },
};

export default GROBAL;
